export default {
    selectedConversation({ conversations, selectedConversationId }) {
        return conversations.find(c => c.id == selectedConversationId);
    },

    conversationsWithUnreadMessagesCount({ conversations }) {
        return conversations.filter(conversation => {
            return conversation.messages.some(message => !message.read);
        }).length;
    },

    viewingOwnConversations({ selectedUserId }, getters, { authUser }) {
        return selectedUserId == authUser.id;
    },
};
